import * as React from "react";
import { styled } from "@mui/material";

//region [[ Styles ]]

const ChatContainerView = styled("div")(
  ({ rtl, embedded }: { rtl?: boolean; embedded?: boolean }) => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: embedded ? "100%" : "inherit",
    maxHeight: embedded ? "none" : "calc(100% - 56px)",
    flex: 1,
    direction: "ltr",
    "& .cs-message": embedded
      ? {
          margin: 0,
        }
      : null,
    "& .scrollbarContainer": embedded
      ? rtl
        ? { paddingLeft: 4 }
        : { paddingRight: 4 }
      : "inherit",
    "& #message-list": {
      flex: 1,
    },
  }),
);

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ChatContainerProps {
  children: React.ReactNode;
  rtlDisplay?: boolean;
  embedded?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const ChatContainer = ({
  children,
  rtlDisplay,
  embedded,
}: ChatContainerProps) => {
  return (
    <ChatContainerView
      embedded={embedded}
      rtl={rtlDisplay}
      className={"chat-container" + rtlDisplay ? " rtl-display" : ""}
    >
      {children}
    </ChatContainerView>
  );
};

export default ChatContainer;
